import { Tooltip as RTooltip, useTooltip, TooltipPopup } from "@reach/tooltip";
import "@reach/tooltip/styles.css";


export const Tooltip : typeof RTooltip = RTooltip;